import React from 'react'
import About from 'src/Components/About'
import Clients from 'src/Components/Clients'
import Teamer from 'src/Components/Team'

const Abouta = () => {
  return (
    <div>
        <About/>
        <Teamer/>
        <Clients/>
    </div>
  )
}

export default Abouta